import type { NuovoFotovoltaicoDTO } from '@/models/dto/fotovoltaico/fotovoltaico-dto'
import type { NewPhotovoltaicPlant } from '@/models/types/photovoltaic/photovoltaic-plant'
import { mapToConfigFotovoltaicoDTO, mapToPhotovoltaicSettings } from './photovoltaic-settings-mapper'

function mapToFotovoltaicoDTO(photovoltaicPlant: NewPhotovoltaicPlant): NuovoFotovoltaicoDTO {
    return {
        id: photovoltaicPlant.id,
        nome: photovoltaicPlant.name ?? null,
        attivo: photovoltaicPlant.active,
        nomeTipologia: photovoltaicPlant.typeName ?? null,
        idTipologieFotovoltaico: photovoltaicPlant.typeId,
        idImpianto: photovoltaicPlant.facilityId ?? null,
        nomeImpianto: photovoltaicPlant.facilityName ?? null,
        iconUrl: photovoltaicPlant.iconUrl ?? null,
        configFotovoltaico: photovoltaicPlant.settings ? mapToConfigFotovoltaicoDTO(photovoltaicPlant.settings) : null,
    }
}

function mapToPhotovoltaicPlant(dto: NuovoFotovoltaicoDTO): NewPhotovoltaicPlant {
    return {
        id: dto.id,
        name: dto.nome ?? undefined,
        active: dto.attivo,
        typeName: dto.nomeTipologia ?? undefined,
        typeId: dto.idTipologieFotovoltaico,
        facilityId: dto.idImpianto ?? undefined,
        facilityName: dto.nomeImpianto ?? undefined,
        iconUrl: dto.iconUrl ?? undefined,
        settings: dto.configFotovoltaico ? mapToPhotovoltaicSettings(dto.configFotovoltaico) : undefined,
    }
}

export { mapToFotovoltaicoDTO, mapToPhotovoltaicPlant }
